<!-- <button pButton type="button" [label]="userLetter" class="p-button-rounded user-menu"></button> -->
<!-- TOP RIGHT MENU BLOCK -->
<!-- LOCATION SELECTOR -->
<div class="top-right-menu-block">
  <!-- LOCATION SELECTOR ICON -->
  <div style="width: 40px; display: flex; align-items: center; justify-content: center">
  <i
    class="pi pi-filter"
    style="font-size: 25px; color: #a5a1a1; cursor: pointer; position: relative"
    (click)="toggleLocationFilterModal()"
    pTooltip="Filter locations"
    tooltipPosition="bottom"
  ></i>
</div>

<div class="download-jobs" [class.has-new-jobs]="hasNewDownloadJobs" [class.loading]="downloadJobsLoading" (click)="toggleDownloadJobsDropdown($event)">
  <i class="pi pi-download download-jobs-icon" title="Exports" aria-label="Exports"></i>
  <i class="pi download-jobs-chevron" [ngClass]="showDownloadJobs ? 'pi-chevron-up' : 'pi-chevron-down'" title="Exports" aria-label="Exports"></i>
</div>

<div *ngIf="showDownloadJobs" class="download-jobs-dropdown" (click)="$event.stopPropagation()">
  <div *ngIf="downloadJobsLoading" class="download-jobs-placeholder">Loading exports...</div>
  <div *ngIf="!downloadJobsLoading && !exportJobs.length" class="download-jobs-placeholder">No export jobs</div>
  <div *ngFor="let job of exportJobs" class="download-job-row">
    <a
      *ngIf="!isJobLinkDisabled(job); else disabledJobLink"
      [href]="job.download_url"
      target="_blank"
      rel="noopener noreferrer"
      >{{ formatExportJobDate(job) }}</a
    >
    <ng-template #disabledJobLink>
      <span class="disabled-job-link">{{ formatExportJobDate(job) }}</span>
    </ng-template>
  </div>
</div>

<!-- Modal Backdrop -->
<div *ngIf="showLocationFilterModal" class="modal-backdrop">
  <div class="modal">
    <div style="background-color: #d9d9d9; padding: 20px; border-radius: 5px">
      <div style="display:flex; align-items:center; justify-content:space-between; gap: 12px;">
        <div style="font-size: 24px">Location Filter</div>

        <!-- AND / OR toggle -->
        <!-- If you use PrimeNG ToggleButton: -->
        <!-- <p-toggleButton [(ngModel)]="isAndMode" onLabel="AND" offLabel="OR" [onIcon]="'pi pi-check'"
                         [offIcon]="'pi pi-minus-circle'"></p-toggleButton> -->

        <!-- Simple fallback toggle using a standard button: -->
        <!--<button
          pButton
          class="p-button-rounded p-button-text"
          type="button"
          (click)="toggleBooleanMode()"
          [label]="isAndMode ? 'AND' : 'OR'"
          [ngClass]="{ 'p-button-success': isAndMode, 'p-button-secondary': !isAndMode }"
          pTooltip="Switch between AND / OR across selected filters"
          tooltipPosition="left"
        ></button>-->
      </div>

      <!-- Exclusive mode helper text -->
      <div *ngIf="hasStoreCodeFilter" class="p-2" style="color:#900000;">
        <i class="pi pi-info-circle"></i>
        Store Code filter is active. Other filters are disabled until you clear the Store Code(s).
      </div>
      <div *ngIf="hasOtherFilters" class="p-2" style="color:#900000;">
        <i class="pi pi-info-circle"></i>
        Other filters are active. Store Code filter is disabled until you clear other selections.
      </div>

      <!-- Filter Categories -->
      <div *ngFor="let cat of filterCategories; trackBy: trackCatByKey" class="filter-category">
        <h3 (click)="cat.expanded = !cat.expanded" class="category-title">
          {{ cat.label }}
          <i class="pi pi-chevron-down arrow" [style.transform]="cat.expanded ? 'rotate(180deg)' : 'none'"></i>
        </h3>

        <div *ngIf="cat.expanded" class="options-list">
          <!-- Single Select All block (works for ALL categories, including storeCode) -->
          <div *ngIf="cat.key !== 'tags'" class="row-input-all">
            <input
              type="checkbox"
              [checked]="isAllSelected(cat.key)"
              (change)="toggleSelectAll(cat.key, $event.target.checked)"
              [disabled]="cat.key === 'storeCode' ? hasOtherFilters : hasStoreCodeFilter"
            />
            <strong>Select All</strong>
          </div>

          <!-- Single options block -->
          <div *ngFor="let option of cat.options; trackBy: trackOption" class="row-input">
            <input
              type="checkbox"
              [value]="option"
              [checked]="isSelected(cat.key, option)"
              (change)="onSelectFilter(cat.key, $event.target.checked, option)"
              [disabled]="cat.key === 'storeCode' ? hasOtherFilters : hasStoreCodeFilter"
            />
            {{ option }}
          </div>
        </div>
        <p-divider
          *ngIf="cat.key === 'storeCode'"
          align="center"
          styleClass="filter-divider"
        >
          <b>Other filters</b>
        </p-divider>
      </div>
    </div>

    <!-- Buttons -->
    <div class="modal-actions">
      <button pButton class="p-button-danger actions_btn" (click)="cancelFilters()">Close</button>
      <button pButton class="p-button-secondary actions_btn" (click)="clearAllFilters()">Clear all</button>
      <button pButton class="p-button-success actions_btn" (click)="applyFilters()">Apply</button>
    </div>
  </div>
</div>


  <!-- NOTIFICATIONS -->
  <div class="notification" (click)="toggleDiv()">
    <i
      style="font-size: 1.7rem; color: #a5a1a1; size: large"
      class="pi pi-bell"
      [pTooltip]="numberUnread ? 'Unread notifications' : null"
    >
      <span *ngIf="numberUnread" pBadge [value]="numberUnread"></span
    ></i>
  </div>
  <div *ngIf="divVisible" class="notification-tray">
    <div class="notification-tray-header">
      <h1>Notifications</h1>
      <p-tabMenu [model]="tabItems" [activeItem]="activeItem" [ngStyle]="{ width: '200px' }"></p-tabMenu>
    </div>
    <div class="notification-tray-notifications" (scroll)="onScroll($event)" *ngIf="activeItem?.label === 'REVIEWS'">
      <div class="div-button-mark-as-read">
        <button class="mark-as-read" [disabled]="!hasUnreadNotifications()" (click)="markAllAsRead(locCounts)">
          Mark all as read
        </button>
      </div>
      <div *ngIf="!locCounts?.length" class="no-notifications">
        <div class="no-notifications-text">No review notifications</div>
      </div>
      <div class="eachNotification" *ngFor="let notification of locCounts">
        <div class="flex-block-1">
          <div class="flex-block-2">
            <div class="dataFirstLine">
              A new {{ notification.reviewPublisher }} Review has been added to location
              {{ notification.storeCode }} ({{ notification.city }}, {{ notification.state }})
            </div>
            <div class="data">
              <div class="data-1">Review date:</div>
              <div>{{ notification.reviewDate }}.</div>
            </div>
            <div class="data">
              <div class="data-2">Reviewer name:</div>
              <div>{{ notification.reviewerName }}.</div>
            </div>
            <div class="data">
              <div class="data-1">Rating:</div>
              <div>{{ notification.starRating }} stars.</div>
            </div>
            <div class="data">
              <div class="data-3">Review text:</div>
              <div class="content">
                <div *ngIf="notification?.reviewComment?.length < 50 && !notification.showFullText">
                  {{ notification.reviewComment | slice : 0 : 50 }}
                </div>
                <div *ngIf="notification?.reviewComment?.length > 50 && !notification.showFullText">
                  {{ notification.reviewComment | slice : 0 : 50 }}
                </div>
                <a
                  *ngIf="notification?.reviewComment?.length > 50 && !notification.showFullText"
                  (click)="notification.showFullText = true; $event.stopPropagation()"
                  class="less-more-style"
                  >More...</a
                >
                <div *ngIf="notification.showFullText">
                  {{ notification.reviewComment }}
                  <a class="less-more-style" (click)="notification.showFullText = false; $event.stopPropagation()"
                    >Less...</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="custom-checkbox">
            <p-checkbox
              binary="true"
              name="group"
              [(ngModel)]="notification.isRead"
              [inputId]="notification.notificationId"
              [pTooltip]="notification.isRead ? 'Mark as unread' : 'Mark as read'"
              (onChange)="updateMarkAsRead(notification)"
            ></p-checkbox>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="activeItem?.label === 'NEW LOCATIONS'">
      <p>New locations tab.</p>
    </div>
  </div>
  <!-- USER -->
  <div class="user-avatar user-menu">
    <img src="/assets/static/default-user.png" />
  </div>
  <!-- USER MENU -->
  <button
    pButton
    class="p-button-text user-menu"
    type="button"
    [label]="menuExpanded ? '&#x25B2;' : '&#x25BC;'"
    (click)="toggleUserMenu($event)"
  ></button>
  <p-menu
    #userMenuRef
    [model]="menuItemsUser"
    [popup]="true"
    [style]="{
      'margin-top': '10px',
      'background-color': 'efefef',
      width: '362.5px'
    }"
    appendTo="body"
  ></p-menu>
</div>
